import API from "../index";

export default class STStand {
  constructor(
    StandName,
    CreatedByEmail,
    CreatedDate,
    LastModifiedByEmail,
    LastModifiedDate,
    IsActive,
    StandTypeName,
    ThisStandType,
    ETQID,
    StationaryTestFacilityName,
  ) {
    const source =
      typeof StandName === "object" && StandName !== null
        ? StandName
        : {
            StandName,
            CreatedByEmail,
            CreatedDate,
            LastModifiedByEmail,
            LastModifiedDate,
            IsActive,
            StandTypeName,
            ThisStandType,
            ETQID,
            StationaryTestFacilityName,
          };

    this.standName = source.standName ?? source.StandName ?? "";
    this.createdByEmail = source.createdByEmail ?? source.CreatedByEmail ?? null;
    this.createdDate = source.createdDate ?? source.CreatedDate ?? null;
    this.lastModifiedByEmail = source.lastModifiedByEmail ?? source.LastModifiedByEmail ?? null;
    this.lastModifiedDate = source.lastModifiedDate ?? source.LastModifiedDate ?? null;
    this.isActive = source.isActive ?? source.IsActive ?? false;
    this.standTypeName = source.standTypeName ?? source.StandTypeName ?? "";
    this.thisStandType = source.thisStandType ?? source.ThisStandType ?? null;
    this.etqid = source.etqid ?? source.ETQID ?? null;
    this.stationaryTestFacilityName =
      source.stationaryTestFacilityName ?? source.StationaryTestFacilityName ?? "";
  }

  static toApiPayload(testStand) {
    const normalizedStand = testStand instanceof STStand ? testStand : new STStand(testStand);
    const toNullable = (value) => (value ? value : null);

    return {
      StandName: toNullable(normalizedStand.standName),
      IsActive: normalizedStand.isActive,
      StandTypeName: toNullable(normalizedStand.standTypeName),
      ETQID: toNullable(normalizedStand.etqid),
      StationaryTestFacilityName: toNullable(normalizedStand.stationaryTestFacilityName),
    };
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get("/ststand");
    return data.result.map((stand) => new STStand(stand));
  }

  static extractErrorMessage(errorLike, fallbackMessage) {
    return (
      errorLike?.response?.data?.message ||
      errorLike?.response?.data?.Message ||
      errorLike?.data?.message ||
      errorLike?.data?.Message ||
      errorLike?.message ||
      fallbackMessage
    );
  }

  static async createTestStand(payload) {
    const api = await API();
    try {
      const { data, status } = await api.post("/ststand", STStand.toApiPayload(payload));
      if (status < 200 || status >= 300) {
        throw new Error(STStand.extractErrorMessage({ data }, "Failed to create test stand"));
      }
      return data;
    } catch (error) {
      throw new Error(STStand.extractErrorMessage(error, "Failed to create test stand"));
    }
  }

  static async updateTestStand(testStand) {
    const api = await API();
    try {
      const { data, status } = await api.put("/ststand", STStand.toApiPayload(testStand));

      if (status < 200 || status >= 300) {
        throw new Error(STStand.extractErrorMessage({ data }, "Failed to update test stand"));
      }
      return data;
    } catch (error) {
      throw new Error(STStand.extractErrorMessage(error, "Failed to update test stand"));
    }
  }
}
